export default class KeyValue {
    /**
     * @type {string}
     * @memberof KeyValue
     * @name key(name)
     */
    public key: string;
    /**
     * @type {string}
     * @memberof KeyValue
     * @name value(value)
     */
    public value: string;
    constructor({key = '', value= ''} = {}) {
        this.key = key;
        this.value = value
    }
}